module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[42]285.756322d.woff2";